import * as Yup from 'yup';

const categoryValidation = Yup.object({
    name: Yup.string().required('Name is required'),
});

export const salesValidation = Yup.object({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().email('Invalid email address').required('Email is required'),
    password: Yup.string().required('Password is required'),
    confirmPassword: Yup.string().required('Confirm password is required').oneOf([Yup.ref('password'), null], 'Passwords must match'),
    // profit: Yup.number().required('Sharing profit is required').max(100, 'Profit percentage must not exceed 100'),
    phoneNo: Yup.string().required('Phone Number is required'),
});

export const oberserventUserValidation = Yup.object({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email address').required('Email is required'),
    phoneNo: Yup.string().required('Phone Number is required'),
    password: Yup.string().required('Password is required'),
    confirmPassword: Yup.string().required('Confirm password is required').oneOf([Yup.ref('password'), null], 'Passwords must match'),

});

export const regionalUserValidation = Yup.object({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email address').required('Email is required'),
    phoneNo: Yup.string().required('Phone Number is required'),
    password: Yup.string().required('Password is required'),
    confirmPassword: Yup.string().required('Confirm password is required').oneOf([Yup.ref('password'), null], 'Passwords must match'),
    profit: Yup.string().required('Sharing profit is required'),
    salesProfit: Yup.string().required('Sales profit is required'),
    rights: Yup.string().required('This field is required'),

});


export default categoryValidation